// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"315":"b711dcd8","508":"585057d7","676":"0148a549","805":"eafd1bb0","973":"c7ddfadf"}[chunkId] + ".css";
};